exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrap[data-v-3f551163]{overflow:hidden}.tips[data-v-3f551163]{width:100%;height:30px;font-size:12px;line-height:30px;color:#413f3a;background:#fefae8;text-align:center}", ""]);

// exports
